import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import type { ImageInputRenderProps } from "@/react/components/shared/ImageUploadInput/ImageInputRender";
import { Button } from "@/react/components/shared/uikit/Button";
import { Loader } from "@/react/components/shared/uikit/Loader";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

export const RenderImagePreview = ({
  value,
  processing: isProcessing,
  imageUrl,
  handleChangeCoverClick,
  handleDelete,
}: ImageInputRenderProps) => {
  const isNewState = !value && !isProcessing;
  const defaultClassName =
    "border-dark bg-selector-active flex h-[134px] w-full flex-col justify-center rounded-lg border border-dashed";

  if (isNewState) {
    return (
      <Button
        className={defaultClassName}
        type="button"
        variant="circle-plain"
        onClick={handleChangeCoverClick}
        data-testid="cover-image-add"
      >
        <Icon
          type="24-builder-ui-sidebar-add-element-filled"
          className="!w-[3rem]"
        />
        <span>{t("add_image")}</span>
      </Button>
    );
  }

  if (isProcessing) {
    return (
      <div className={defaultClassName}>
        <Loader />
      </div>
    );
  }

  return (
    <div
      className="border-primary flex flex-col gap-y-3 rounded-lg border"
      data-testid="cover-image-preview"
    >
      <div className="px-3 pt-3">
        <img
          src={imageUrl}
          alt=""
          className={classNames(defaultClassName, "border-solid")}
          loading="eager"
        />
      </div>
      <div className="border-primary flex flex-row items-center justify-between border-t p-3">
        <Button
          type="button"
          variant="link"
          onClick={handleChangeCoverClick}
          data-testid="cover-image-replace"
          className="!p-0"
        >
          <Typography.LabelXs weight="semibold">
            {t("replace")}
          </Typography.LabelXs>
        </Button>
        <Button
          type="button"
          variant="circle-plain"
          onClick={handleDelete}
          className="hover:text-dark !hover:bg-primary !p-0"
          data-testid="cover-image-delete"
        >
          <Icon type="20-trash-bin" viewBox="0 0 20 20" />
        </Button>
      </div>
    </div>
  );
};
